import http from "../http/http-config";
import { DiscountRangeResponse } from "../models/discountRangeResponse";

export default new class discountRangeService {
    getUrbanMovilityDiscountRange(): Promise<DiscountRangeResponse[]> {
        return http.get<DiscountRangeResponse[]>("GetDiscountRange/GetUrbanMovilityDiscountRange", {
            params: {
            }
        }).then(response => response.data)
    }
    getElectronicEquipmentDiscountRange(): Promise<DiscountRangeResponse[]> {
        return http.get<DiscountRangeResponse[]>("GetDiscountRange/GetElectronicEquipmentDiscountRange", {
            params: {
            }
        }).then(response => response.data)
    }
    getSafeHealthMaxDiscountRange(): Promise<DiscountRangeResponse[]> {
        return http.get<DiscountRangeResponse[]>("GetDiscountRange/GetSafeHealthMaxDiscountRange", {
            params: {
            }
        }).then(response => response.data)
    }
    getFamilyCombinedDiscountRange(): Promise<DiscountRangeResponse[]> {
        return http.get<DiscountRangeResponse[]>("GetDiscountRange/GetFamilyCombinedPremiumDiscountRange", {
            params: {}
        }).then(response => response.data);
    }
}

